var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeeper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C5.33329 2 3.66663 4.77778 3.66663 4.77778C3.66663 4.77778 3.66663 12.5556 3.66663 15.8889C3.66663 19.2222 10.3333 22 10.3333 22V13.6667H9.22218C7.99488 13.6667 6.99996 12.6717 6.99996 11.4444V10.8218C6.99996 9.41946 8.28542 8.36194 9.67898 8.5185C10.4299 8.60286 11.2469 8.66667 12 8.66667",
    stroke: "#7075E9",
    strokeWidth: 2.22222,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C18.6667 2 20.3334 4.77778 20.3334 4.77778C20.3334 4.77778 20.3334 12.5556 20.3334 15.8889C20.3334 19.2222 13.6667 22 13.6667 22V13.6667H14.7778C16.0051 13.6667 17 12.6717 17 11.4444V10.8218C17 9.41946 15.7146 8.36194 14.321 8.5185C13.5701 8.60286 12.7531 8.66667 12 8.66667",
    stroke: "#7075E9",
    strokeWidth: 2.22222,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeper);
export default __webpack_public_path__ + "static/media/keeper.2ff46e1f146e9bcef969dbb4fb88dca8.svg";
export { ForwardRef as ReactComponent };